// extracted by mini-css-extract-plugin
export default {"icon":"rzy70G","innerIcon":"Aa6Xr6"};